import {SimpleValue} from '../moviePrimitives.types';

function simpleMovieValue<G>(val: G): SimpleValue<G> {
  return {
    val,
    a: 0,
    ix: 0,
    mult: 1,
    sh: false,
  };
}

export default simpleMovieValue;
